export default __webpack_public_path__ + "static/img-1-78702dc34b1b4c089559f96cb93a21e1.png";